import React from 'react'

const Footer = () => {
  return (
    <footer className="pie text-center text-md-right bg-dark text-white mt-4">
   <div className="container">
     <p className="m-0 py-3">Stephanie Labarca © 2020. Todos los derechos reservados.</p>
   </div>
 </footer>
  )
}
 
export default Footer;

